import { IReduxState } from "./reducers.interfaces";

export const defaults: Readonly<IReduxState> = {
    // Product Data
    entities: {
        rootProducts: [],
        variantPrefilter: null,
        price: null,
        concreteBundles: [],
        upsellInfoModals: [],
        promoCards: [],
        productClass: null,
    },

    // UI State Data
    ui: {
        // Product option selector state
        selectedRoot: null,
        optionValues: {},
        quantity: 1,

        // History
        previousSelectionState: null,

        // Product Upgrades
        selectedUpgrade: null,
        upsellInfoModalActiveBundle: null,

        // Product Add-Ons
        selectedAddons: [],

        // Add to basket button
        addToBasketCooldownActive: false,
        addToBasketButtonText: "Add to cart",

        // Add to favorites button
        addToFavoritesButtonText: "Save to favorites",

        // Add to basket error modal
        addToBasketErrorOpen: false,
        addToBasketErrorReason: "",

        ratingsModalOpen: false,

        // Options pannel
        optionSelectionErrorReason: "",
        panelTriggerClicked: false,
    },

    shippingMethod: null,
};
